import { Component, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';

@ManageType('PatientCareTeamDialogComponent')
@Component({
  selector: 'app-patient-care-team-dialog',
  templateUrl: './patient-care-team-dialog.component.html',
  styleUrls: ['./patient-care-team-dialog.component.scss']
})
export class PatientCareTeamDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
